import { createStore, applyMiddleware } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk'

import rootReducer from '../reducers';

// USed as entry point of appliaxtion
// Look at index.js in root

// This way store is confiogured when the app starts up
// Serverside rendering
// good way to initilize store with some state
// initial state of applixatin
// Returns call to createStore
export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        // apply'middleware comes with redux
    applyMiddleware(
        thunk,
        reduxImmutableStateInvariant() // Called version, invoked
    )
)
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js